import sat from './sat.jpg';
import ssat from './ssat.jpg';
import sat2 from './sat2.jpg';
import act from './act.jpg';
import ap from './ap.jpg';
import ela from './ela.jpg';
import college from './college.jpg';
import mentor from './mentor.jpg';
import boarding from './boarding.jpg';
import drawing from './drawing.jpg';

export { 
  sat,
  ssat,
  sat2,
  act,
  ap,
  ela,
  college,
  mentor,
  boarding,
  drawing,
}